module.exports = __webpack_public_path__ + "img/06.92531c11.png";